// extracted by mini-css-extract-plugin
module.exports = {"page_row":"News_page_row__3qSUf","all_news":"News_all_news__2Fxi-","single_news":"News_single_news__2OmY5"};